import { useContext, useEffect, useState } from "react";

import OnboardingBoilerplate from "./OnboardingBoilerplate";
import extractEventValue from "../../../../controllers/utils/extractEventValue";
import MaterialInput from "../../../helperComponents/MaterialInput";
import styled from "styled-components";
import { serverLine } from "../../../../controllers/network/serverLine";
import Context from "../../../../Context";
import { useTranslation } from "react-i18next";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  width: 100%;
`;

export default function AskDonationInfo({ asEditPage }) {
  const { loggedInUser, setLoggedInUser } = useContext(Context);
  const { t } = useTranslation();
  const [upiId, setUpiID] = useState("");
  const [bankDetails, setBankDetails] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (loggedInUser) {
      setUpiID(loggedInUser.upiID);
      setBankDetails(loggedInUser.bankDetails);
    }
  }, []);

  let title = "UPI ID & Bank Detail";

  return (
    <OnboardingBoilerplate
      editPageTitle="Donation Details"
      asEditPage={asEditPage}
      skipID={"donationOnboardingSkipped"}
      title={title}
      desc={"Donation will be received here"}
      onSubmit={onSubmit}
      loading={loading}
    >
      <Container>
        <MaterialInput
          label={"Upi ID"}
          value={upiId}
          onChange={extractEventValue(setUpiID)}
        />
        <MaterialInput
          multiline={true}
          rows={5}
          label={"Bank Details"}
          value={bankDetails}
          onChange={extractEventValue(setBankDetails)}
        />
      </Container>
    </OnboardingBoilerplate>
  );

  async function onSubmit() {
    if (!upiId) return window.popupAlert("Please type the bio");

    setLoading(true);

    try {
      await serverLine.patch("/me", {
        changes: { upiId, bankDetails },
      });
      setLoading(false);
      let newLoggedInUser = { ...loggedInUser, upiId, bankDetails };
      setLoggedInUser(newLoggedInUser);
      window.popupAlert(t("saved"));
    } catch (e) {
      window.popupAlert(e.message);
      setLoading(false);
    }
  }
}
